import { render } from "./textarea.vue?vue&type=template&id=c0fb372e&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import "./textarea.vue?vue&type=style&index=0&id=c0fb372e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1199873226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fb372e"]])

export default __exports__